import React, { useState, useEffect } from "react";

const TypewriterEffect = () => {
  const [text, setText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const [typingSpeed, setTypingSpeed] = useState(50);
  const [isPaused, setIsPaused] = useState(false);
  const words = [
    "תזכורות ועדכונים ללקוחות בוואטסאפ ללא הגבלה.",
    "ניצול מקסימלי של ניהול הזמן בזכות רשימת המתנה",
    "ניהול יומן בנפרד לצוות עובדים בממשק אחד.",
    "לאפשר לקבוע תור בתשלום מראש כדי למנוע חורים ביומן",
  ];

  useEffect(() => {
    const word = words[loopNum % words.length];

    if (isPaused) {
      const pauseTimer = setTimeout(() => {
        setIsPaused(false);
        setIsDeleting(true);
        setTypingSpeed(30);
      }, 2200);
      return () => clearTimeout(pauseTimer);
    }

    const timer = setTimeout(() => {
      if (!isDeleting) {
        setText((prev) => word.substring(0, prev.length + 1));
        if (text === word) setIsPaused(true);
      } else {
        setText((prev) => word.substring(0, prev.length - 1));
        if (text === "") {
          setIsDeleting(false);
          setLoopNum(loopNum + 1);
          setTypingSpeed(50);
        }
      }
    }, typingSpeed);

    return () => clearTimeout(timer);
  }, [text, isDeleting, loopNum, typingSpeed, isPaused]);

  return (
    <div
      style={{
        minHeight: "4.5rem",
        direction: "rtl",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: "8px 0",
        marginBottom: "8px",
      }}
    >
      <p
        style={{
          fontFamily: "'Rubik', 'Heebo', sans-serif",
          fontWeight: 700,
          fontSize: "clamp(1.05rem, 2vw, 1.25rem)",
          lineHeight: 1.5,
          margin: 0,
          background: "linear-gradient(135deg, #ffe8a0 0%, #fff6cc 60%, #ffe066 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          textShadow: "none",
          letterSpacing: "0.01em",
        }}
      >
        <span>{text}</span>
        <span
          style={{
            display: "inline-block",
            width: "2px",
            height: "1.1em",
            background: "#ffe066",
            verticalAlign: "text-bottom",
            marginRight: "3px",
            borderRadius: "1px",
            animation: "twBlink 1s step-end infinite",
          }}
        />
      </p>
      <style>{`
        @keyframes twBlink {
          0%, 100% { opacity: 1; }
          50%       { opacity: 0; }
        }
      `}</style>
    </div>
  );
};

export default TypewriterEffect;
